const splitStr = (str) => {
  let data = "";
  if (str) {
    data = str
      .split(" ")
      .filter((item) => item != "")
      .splice(0, 2)
      .join(" ");
  }

  return data;
};

export { splitStr };
